import React from "react";

import { useOneShotHook } from "./use-one-shot-hook";

import styles from "./one-shot.module.scss";

import oneShotImage from "@src/assets/png/one-shot.png";
import { useI18N } from "@src/language/language-context";

const cssClassName = "one-shot";

export const OneShot = () => {
  const i18n = useI18N();
  useOneShotHook();

  const texts = {
    oneShotAltText: i18n("modules.oneShot.oneShotAltText"),
  };

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__responsive-container`]}>
        <img
          src={oneShotImage}
          alt={texts.oneShotAltText}
          className={styles[`${cssClassName}__responsive-image`]}
        />
      </div>
    </div>
  );
};
